<template>
  <div class="purchase-method-detail-base-info">
    <div class="info-block">
      <div class="info-item">
        <div class="label">请假人：</div>
        <div class="value">{{data.workerName}}</div>
      </div>
      <div class="info-item">
        <div class="label">请假类型：</div>
        <div class="value">{{data.type}}</div>
      </div>
      <div class="info-item">
        <div class="label">开始时间：</div>
        <div class="value">{{data.startTime}}</div>
      </div>
      <div class="info-item">
        <div class="label">结束时间：</div>
        <div class="value">{{data.endTime}}</div>
      </div>
      <div class="info-item">
        <div class="label">请假时长：</div>
        <div class="value">{{data.timeLong}}</div>
      </div>
    </div>
    <div class="info-block">
      <div class="info-item">
        <div class="label">请假事由：</div>
        <div class="value">{{data.reson}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: { type: Object, defualt: () => null }
  },
  computed: {
    purchaseBatchDetailList () {
      return this.data && this.data.purchaseBatchDetailList ? this.data.purchaseBatchDetailList : []
    }
  }
}
</script>

<style lang="less" scoped>
.purchase-method-detail-base-info {
  color: #515a6e;
  .info-block {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }
  .detail-info {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #e8eaec;
  }
  .info-item {
    display: flex;
    margin-right: 50px;
    margin-bottom: 5px;
    .label {
      margin-right: 0px;
      white-space: nowrap;
    }
  }
}
</style>